import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var deleteMobileDevice = mutatorAction('deleteMobileDevice', function (selected) {
    var store = mobileDeviceFullStore();
    var devices = [];
    var index = 0;
    for (index = 0; index < store.devices.length; index++) {
        if (index !== selected) {
            devices.push(store.devices[index]);
        }
    }
    store.devices = devices;
    store.selected = -1;
});
//# sourceMappingURL=deleteMobileDevice.js.map